import React, { useState } from "react"
import { NumericFormat } from "react-number-format"
import ToolTip from "@/components/core/ToolTip/ToolTip"

export const OrderSummaryItem = ({
  label,
  value,
  icon,
  children,
  id,
  prefix = "",
  freeShipping = null,
  tooltip = null,
  alt = ``,
  role = "",
  customCls = "",
  valueSize = "",
  onClick = () => {},
  decimalScale = 2,
  onMouseOver,
  type,
}) => {
  const [tooltipFlag, setTooltipFlag] = useState(false)
  const keyProp = id ? { key: id } : {}
  return (
    <>
      <div {...keyProp} className={`order-summary__item  ${customCls}`}>
        <span className="order-summary__item--label">
          {label && label}
          {icon && (
            <img
              src={icon}
              role={role ?? "tooltip"}
              margin="unset"
              alt={alt}
              className={"order-summary__tooltip-icon"}
              onMouseOver={() => {
                setTooltipFlag(true)
                onMouseOver(type)
              }}
              onMouseOut={() => setTooltipFlag(false)}
              onClick={onClick}
            />
          )}
          {children && children}
          {tooltip && (
            <div
              className={`order-summary__tooltip--${
                tooltipFlag ? "show" : "hide"
              }`}
            >
              <div className="order-summary__tooltip-wrapper">
                <ToolTip message={tooltip} />
              </div>
            </div>
          )}
        </span>
        <span
          className={`order-summary__item--value${
            valueSize ? `-${valueSize}` : ""
          }`}
        >
          {!isNaN(value) ? (
            <NumericFormat
              value={parseFloat(value ?? 0).toFixed(decimalScale)}
              displayType={"text"}
              thousandSeparator={true}
              prefix={prefix ?? ""}
            />
          ) : (
            value
          )}
        </span>
      </div>
    </>
  )
}
